// extracted by css-extract-rspack-plugin
export default {"menu":"menu-fjz4Jo","menuList":"menuList-OZVpIU","menuItem":"menuItem-wpgFNL"};